<script>
	export let name;
</script>

<main>
	<img class="logo" src="/logo.png" alt="RftG logo" />
	<br />
	<br />
	<br />
	<br />
	<h1>{name}</h1>	
	<h1>Coming soon...</h1>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		font-family: 'Mittelschrift', sans-serif;
		font-size: 3rem;
		background-image: linear-gradient(to top, #0021f9, #efefef, #0021f9);
		-webkit-background-clip: text;
		background-clip: text;
		color: transparent;
		-webkit-text-fill-color: transparent;
		text-transform: uppercase;
		font-weight: bold;
		white-space: nowrap;
		text-shadow: 0 0 5px #efefef, 0 0 14px #efefef, 0 0 21px #efefef, 0 0 28px #0021f9, 0 0 49px #0021f9, 0 0 70px #0021f9, 0 0 105px #0021f9;
		animation: glow 5s ease-in-out infinite;
	}

	@keyframes glow {
		0% {
			text-shadow: 0 0 5px #efefef, 0 0 14px #efefef, 0 0 21px #efefef, 0 0 28px #0021f9, 0 0 49px #0021f9, 0 0 70px #0021f9, 0 0 105px #0021f9;
		}
		50% {
			text-shadow: 0 0 2px #efefef, 0 0 7px #efefef, 0 0 10px #efefef, 0 0 14px #0021f9, 0 0 25px #0021f9, 0 0 35px #0021f9, 0 0 52px #0021f9;
		}
		100% {
			text-shadow: 0 0 5px #efefef, 0 0 14px #efefef, 0 0 21px #efefef, 0 0 28px #0021f9, 0 0 49px #0021f9, 0 0 70px #0021f9, 0 0 105px #0021f9;
		}
	}

	.logo {
		width: 70%;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}

	@media (max-width: 768px) {
  		h1 {
			font-size: 0.8rem;
  		}
    }
</style>